

import { Download, AlertTriangle, TrendingUp, Clock, MapPin } from "lucide-react";
import Chart from "react-apexcharts";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { IoWarning, IoWarningOutline } from "react-icons/io5";
import { FaArrowTrendUp } from "react-icons/fa6";
import { MdOutlineWatchLater } from "react-icons/md";
import { BiMap } from "react-icons/bi";
import { useEffect, useMemo, useState } from "react";
import AreaService from "../../../../../api/areaService";
import { executive_summary_for_report, get_alerts_for_report } from "../../../../../RenderPDFformat/utils/reportApiUtils";
import { TiTick } from "react-icons/ti";
import { CgCheckO } from "react-icons/cg";


const DailySafetyReport = ({ filters, isPdfRendering, apiData, MOCData }) => {

  const factoryName = JSON.parse(localStorage.getItem('userData')).factory.name


console.log('MOC cards receiving', MOCData)
 const timeBasedAlerts = apiData?.alertsChartsData.y_axis
 console.log('show me apiData pdf', apiData)

  const [subareamatrics, setsubareamatrics] = useState([])


const getSeries = (it) => {
  if (filters?.week && filters.week !== "") {
    // If filters.week is an array of day keys, use them.
    // e.g. ["monday","tuesday","wednesday"] or any 3 day keys you pass in.
    if (Array.isArray(filters.week) && filters.week.length === 3) {
      return filters.week.map((d) => Number(it?.[d]) || 0);
    }
    // If it's a single value or something else, default to Mon/Tue/Wed.
    return [
      Number(it?.monday) || 0,
      Number(it?.tuesday) || 0,
      Number(it?.wednesday) || 0,
    ];
  }

  // default: keep shift-wise behavior
  return [
    Number(it?.shiftA) || 0,
    Number(it?.shiftB) || 0,
    Number(it?.shiftC) || 0,
  ];
};


  // Step 5: Set state

  const [areashiftwise, setareashiftwise] = useState({
    categories: [],
    data: []
  });

  const [totalareachart, settotalareachart] = useState({
    categories: [],
    data: []
  });

  const [shiftcomparison, setshiftcomparison] = useState({
    categories: [],
    data: []
  })
  const [subareaanalysis, setsubareaanalysis] = useState({
    categories: [],
    data: []
  })

  const getDateRange = (startStr, endStr) => {
    const start = new Date(startStr);
    const end = new Date(endStr);
    const dates = [];

    while (start <= end) {
      dates.push(new Date(start)); // Clone actual Date object
      start.setDate(start.getDate() + 1);
    }

    return dates;
  };

  const [moduleanalysis, setmoduleanalysis] = useState({
    labels: [],
    series: []
  })

  const [modulebyshift, setmodulebyshift] = useState({})



  
const DAYS = filters?.week!=='' ? [
  { key: "monday", pctKey: "mondayPercentage", label: "Monday" },
  { key: "tuesday", pctKey: "tuesdayPercentage", label: "Tuesday" },
  { key: "wednesday", pctKey: "wednesdayPercentage", label: "Wednesday" },
  { key: "thursday", pctKey: "thursdayPercentage", label: "Thursday" },
  { key: "friday", pctKey: "fridayPercentage", label: "Friday" },
  { key: "saturday", pctKey: "saturdayPercentage", label: "Saturday" },
  { key: "sunday", pctKey: "sundayPercentage", label: "Sunday" },
]: filters?.month!=='' ? (() => {
      const rows = apiData?.moduleAnalysis?.shiftWiseAlertsChart || [];
      const sample = rows[0] || {};
      // find week keys like "week01", "week02", ...
      const weekKeys = Object.keys(sample).filter(k => /^week\d{2}$/i.test(k));
      // sort by week number
      weekKeys.sort((a, b) => parseInt(a.slice(4), 10) - parseInt(b.slice(4), 10));
      // build [{ key, pctKey, label }]
      return weekKeys.map(wk => ({
        key: wk,
        pctKey: `${wk}Percentage`,
        label: `Week ${parseInt(wk.slice(4), 10)}`
      }));
    })() : filters?.date!=='' && [
  { key: "shiftA", pctKey: "shiftAPercentage", label: "Shift A" },
  { key: "shiftB", pctKey: "shiftBPercentage", label: "Shift B" },
  { key: "shiftC", pctKey: "shiftCPercentage", label: "Shift C" },

]
  const dayTotals = useMemo(() => {
  const totals = filters?.week!=='' ? {
    monday: 0, tuesday: 0, wednesday: 0,
    thursday: 0, friday: 0, saturday: 0, sunday: 0,
  } : filters?.date!=='' ?  {
    shiftA: 0, shiftB: 0, shiftC: 0,
    
  } : filters?.month !== ''
  ? (() => {
      const rows = apiData?.moduleAnalysis?.shiftWiseAlertsChart || [];
      const sample = rows[0] || {};
      const weekKeys = Object.keys(sample).filter(k => /^week\d{2}$/i.test(k));
      const obj = {};
      weekKeys.forEach(wk => { obj[wk] = 0; });
      return obj;
    })()
  : {};
  const rows = apiData?.moduleAnalysis?.shiftWiseAlertsChart || [];
  rows.forEach((row) => {
    DAYS.forEach((d) => {
      totals[d.key] += Number(row?.[d.key] || 0);
    });
  });
  return totals;
}, [apiData]);
// 1) Add a module → color map (replace hexes with your exact brand colors)

  useEffect(() => {
   
const areas = apiData?.complianceSubArea?.areas || [];

const subareamatricss = areas.flatMap(area => area.sub_areas || []);

const totalAreaCategories = apiData?.areaWiseChart.map((item)=>item.area)

const totalAreaSeries = apiData?.areaWiseChart.map((item)=>item.total_alerts)



settotalareachart({
  categories: totalAreaCategories,
   data: [{ name: "Total Alerts ", data: totalAreaSeries }]
})

// categories = areas


// series = Shift A, Shift B, Shift C
const seriesAreaShift = ["Shift A", "Shift B", "Shift C"].map(shiftName => ({
  name: shiftName,
  data: apiData?.areaWiseChart.map(item => item.shift_distribution?.[shiftName] ?? 0)
}));

console.log('shift area series', seriesAreaShift)

setareashiftwise({
  categories: totalAreaCategories,
  data: seriesAreaShift
});




const pickShiftValue = (subArea, shiftLabel, field = 'non_compliance_count') => {
  const item = subArea?.shift_analysis?.find(
    s => (s.shift || '').toLowerCase() === shiftLabel.toLowerCase()
  );
  // default to 0 if missing
  return Number(item?.[field] ?? 0);
};

// Build the 3 series using compliance_percentage (fits stacked % bars nicely)
const series = [
  {
    name: 'Shift A',
    data: (subareamatricss ?? []).map(sa => pickShiftValue(sa, 'Shift A', 'non_compliance_count')),
  },
  {
    name: 'Shift B',
    data: (subareamatricss ?? []).map(sa => pickShiftValue(sa, 'Shift B', 'non_compliance_count')),
  },
  {
    name: 'Shift C',
    data: (subareamatricss ?? []).map(sa => pickShiftValue(sa, 'Shift C', 'non_compliance_count')),
  },
];

console.log('sub area details',subareamatricss);

setsubareamatrics(subareamatricss)

const finalUpdate = {
  categories: subareamatricss,
  data: series
}

console.log('final update', finalUpdate)
setsubareaanalysis(finalUpdate)





const sc = apiData?.shiftComparison?.shift_counts || {};

// Find the first available week key from any shift
const weekKey = Object.values(sc)
  .map(shiftObj => (shiftObj ? Object.keys(shiftObj)[0] : undefined))
  .find(Boolean);

// Build a union of day names across all shifts for that week
const daySet = new Set();
if (weekKey) {
  Object.values(sc).forEach(weeks => {
    const days = weeks?.[weekKey] ? Object.keys(weeks[weekKey]) : [];
    days.forEach(d => daySet.add(d));
  });
}

// Sort days Monday→Sunday, but only those present
const orderMap = {
  Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4,
  Friday: 5, Saturday: 6, Sunday: 7
};
const categories = Array.from(daySet).sort((a, b) => {
  const ai = orderMap[a] ?? 99;
  const bi = orderMap[b] ?? 99;
  return ai - bi || a.localeCompare(b);
});

// Build series for each shift aligned to categories; default to 0
const data = Object.entries(sc).map(([shiftName, weeks]) => {
  const dayCounts = weeks?.[weekKey] || {};
  return {
    name: shiftName,
    data: categories.map(day => Number(dayCounts[day] ?? 0)),
  };
});
if(filters?.month!==''){
  const keysArray = Object.keys(apiData?.shiftComparison?.daily_counts || []);
  
  const weekLabels = keysArray.map(k => k.split(" (")[0]);
  const sc = apiData?.shiftComparison?.shift_counts || {};
  const dataa = Object.entries(sc).map(([shiftName, weeks]) => {
    return {
      name: shiftName,
      data: keysArray.map(weekKey => Number(weeks?.[weekKey] ?? 0)),
    };
  });

  console.log('week labels', weekLabels)
  console.log('keysarray', dataa)
  
  setshiftcomparison({
    categories: weekLabels,
    data: dataa
  });
  console.log('shift comparison week', dataa)

}
else{
 console.log('week labels', categories)
  console.log('keysarray', data)
  setshiftcomparison({ categories, data });
}



// const areaTotals = {};
// const areaSet = new Set();

// // Step 1: Collect all unique area keys and initialize totals
// apiData.areaWiseChart.forEach(item => {
//   const areas = item.areas || {};
//   Object.keys(areas).forEach(areaKey => {
//     areaSet.add(areaKey);
//     if (!areaTotals[areaKey]) {
//       areaTotals[areaKey] = 0;
//     }
//     areaTotals[areaKey] += areas[areaKey].total || 0;
//   });
// });

// const areaKeys = Array.from(areaSet).sort((a, b) => {
//   const numA = parseInt(a.split('-')[1], 10);
//   const numB = parseInt(b.split('-')[1], 10);
//   return numA - numB;
// });

// const update = areaKeys.map(key => areaTotals[key])
// // Step 2: Set the chart data
// console.log('update', update)
// settotalareachart({
//   categories: areaKeys,
//   data: [
//     {
//       name: 'Total Alerts ',
//       data: update
//     }
//   ]
// });


const moduleSeries = apiData?.moduleAnalysis?.totalAlertsChart?.map((item)=>item?.percentage)

const moduleLabels = apiData?.moduleAnalysis?.totalAlertsChart?.map((item)=>item?.category)

setmoduleanalysis(()=>({
  labels: moduleLabels,
  series: moduleSeries
}))



// helper: returns [a,b,c] based on filters.week or falls back to shifts
   const rows = apiData?.moduleAnalysis?.shiftWiseAlertsChart || [];
    const shaped = {};

    rows.forEach((row) => {
      if (!row || !row.category) return;

      const total =
        typeof row.total === "number"
          ? row.total
          : DAYS.reduce((acc, d) => acc + (Number(row[d.key]) || 0), 0);

      shaped[row.category] = DAYS.map((d) => ({
        dayKey: d.key,
        dayLabel: d.label,
        count: Number(row[d.key]) || 0,
        percentage:
          typeof row[d.pctKey] === "number" ? Number(row[d.pctKey]) : null,
        total,
      }));
    });

    setmodulebyshift(shaped);





  }, [apiData]);


 const pieOptions = (title, subtitlePct) => ({
    chart: { type: "pie" },
    labels: [title, `Other ${filters?.week ? 'days' : filters?. month ? 'weeks' : 'shifts'} Alerts `],
    legend: { show: true, position: "bottom" }, 
   dataLabels: {
  enabled: true,
  formatter: (val, opts) => {
    return `${opts.w.config.series[opts.seriesIndex]} Alerts `; // shows raw value instead of %
  },
   style: {
    fontSize: "11px",   // ✅ increase font size
   
 
  },
},
    title: { text: title, style: { fontSize: "15px" } },
    subtitle:
      subtitlePct !== null && subtitlePct !== undefined
        ? { text: `Compliance: ${subtitlePct}%`, style: { fontSize: "15px" } }
        : undefined,
    tooltip: { y: { formatter: (v) => `${v}` } },
  });

  const generateKeyFindings = () => {
    if ((totalareachart.data.length <= 0 || totalareachart.categories.length <= 0 || areashiftwise.data.length <= 0)) {
      return;
    }
    const findings = [];

    // 1. Finding the highest activity area across all shifts:
    const maxTotalActivity = Math.max(...totalareachart.data);
    if (!isNaN(maxTotalActivity)) {
      const maxTotalArea = totalareachart.categories[totalareachart.data.indexOf(maxTotalActivity)];
      findings.push(`${maxTotalArea} shows the highest activity across all shifts (${maxTotalActivity} total Alerts )`);
    }

    // 2. Shift A's highest activity area
    const maxShiftAActivity = Math.max(...areashiftwise.data[0].data);
    if (!isNaN(maxShiftAActivity)) {
      const maxShiftAArea = totalareachart.categories[areashiftwise.data[0].data.indexOf(maxShiftAActivity)];
      findings.push(`Shift A consistently shows higher Alerts rates in ${maxShiftAArea} (${maxShiftAActivity} Alerts )`);
    }

    // 3. Shift B's peak activity
    const maxShiftBActivity = Math.max(...areashiftwise.data[1].data);
    if (!isNaN(maxShiftBActivity)) {
      const maxShiftBArea = totalareachart.categories[areashiftwise.data[1].data.indexOf(maxShiftBActivity)];
      findings.push(`${maxShiftBArea} shows peak activity during Shift B (${maxShiftBActivity} Alerts )`);
    }

    // 4. Finding an area with low alerts across all shifts (e.g., Office Area, lowest total alerts)
    const minTotalActivity = Math.min(...totalareachart.data);
    if (!isNaN(minTotalActivity)) {
      const minTotalArea = totalareachart.categories[totalareachart.data.indexOf(minTotalActivity)];
      findings.push(`${minTotalArea} maintains consistently low Alerts rates across all shifts (${minTotalActivity} Alerts )`);
    }

    return findings;
  };


  // [2, 3, 4, 6, 8, 10, 8, 6, 4, 2];
  const timeLabels = apiData?.alertsChartsData.x_axis
  // const timeLabels = ['06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00'];
  const neww = timeBasedAlerts?.length > 0 ? timeBasedAlerts : [0]
  // Line Chart Options for Time-Based Alert Analysis
  const dataMax = Math?.max(...neww);
  const lineChartOptions = {
    chart: {
      type: 'line',
      height: 300,
      toolbar: {
        show: false
      }
    },
    stroke: {
      curve: 'smooth',
      width: 3
    },
    colors: ['#8884d8'],
    xaxis: {
      categories: timeLabels,
      title: {
        text: 'Time'
      }

    },
    yaxis: {
      title: {
        text: 'Number of Alerts '
      },
      max: dataMax ? dataMax + 1 : 2,
      tickAmount: (dataMax + 1) > 5 ? 5 : dataMax + 1,
      forceNiceScale: true
    },
    grid: {
      strokeDashArray: 3
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " Alerts "
        }
      }
    },
    legend: {
      show: true,
      labels: {
        colors: ['#333']
      }
    },
    annotations: {
      points: [{
        x: '16:00',
        y: 10,
        marker: {
          size: 8,
          fillColor: '#dc3545',
          strokeColor: '#fff',
          strokeWidth: 2
        },
        label: {
          text: 'Peak Hour',
          style: {
            color: '#fff',
            background: '#dc3545'
          }
        }
      }]
    }
  };








  const lineChartSeries = [{
    name: 'Shift A (Peak at Hour 6-8 Alerts )',
    data: timeBasedAlerts
  }];
  const [firstseries, setfirstseries] = useState([
    {
      name: "Day Shift",
      data: [2, 4, 6, 4, 5, 6, 3, 5, 6, 4, 3, 2, 5, 6, 3, 4, 4, 2, 3, 5, 4, 2, 3, 2],
    },
    {
      name: "Night Shift",
      data: [1, 2, 3, 2, 3, 4, 2, 3, 4, 2, 2, 1, 3, 4, 2, 2, 2, 1, 2, 3, 2, 1, 2, 1],
    },
    {
      name: "Weekend",
      data: [0, 1, 2, 1, 1, 2, 1, 2, 2, 1, 1, 0, 2, 2, 1, 1, 1, 0, 1, 2, 1, 0, 1, 0],
    },
  ])



  const shiftChartOptions = {
    chart: {
      // id: "alerts",
      toolbar: { show: false },
      background: "transparent",
    },
    xaxis: {
      categories: shiftcomparison.categories,
      labels: {
        style: {
          fontSize: "10px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "10px",
        },
      },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    colors: ["#8b5cf6", '#74f7a9', '#f77474'],
    grid: {
      show: true,
      strokeDashArray: 3,
    },
  };

  const shiftChartSeries = [
    {
      name: "Day Shift",
      data: [2, 4, 6, 4, 5, 6, 3, 5, 6, 4, 3, 2, 5, 6, 3, 4, 4, 2, 3, 5, 4, 2, 3, 2],
    },
    {
      name: "Night Shift",
      data: [1, 2, 3, 2, 3, 4, 2, 3, 4, 2, 2, 1, 3, 4, 2, 2, 2, 1, 2, 3, 2, 1, 2, 1],
    },
    {
      name: "Weekend",
      data: [0, 1, 2, 1, 1, 2, 1, 2, 2, 1, 1, 0, 2, 2, 1, 1, 1, 0, 1, 2, 1, 0, 1, 0],
    },
  ];

  const pyramidData = [
    { level: "Fatality/Class A", color: "#7f1d1d", fy2024: 0, ytd2024: 0, ytd2025: 0 },
    { level: "LTA", color: "#991b1b", fy2024: 1, ytd2024: 1, ytd2025: 0 },
    { level: "RWC", color: "#b91c1c", fy2024: 0, ytd2024: 0, ytd2025: 0 },
    { level: "MTC", color: "#ea580c", fy2024: 0, ytd2024: 0, ytd2025: 0 },
    { level: "FAC", color: "#f97316", fy2024: 15, ytd2024: 3, ytd2025: 5 },
    { level: "Near Miss", color: "#fb923c", fy2024: 144, ytd2024: 57, ytd2025: 68 },
    { level: "Hazards", color: "#eab308", fy2024: 10065, ytd2024: 4352, ytd2025: 4217 },
    { level: "Alerts", color: "#facc15", fy2024: 3346, ytd2024: 896, ytd2025: 1383 },

  ];


  const totalAlertsData = {
    categories: [
      "Production Floor",
      "Warehouse",
      "Loading Dock",
      "Office Area",
      "Maintenance Shop",
      "Storage Area",
    ],
    series: [31, 21, 19, 8, 27, 15], // approximate from image
  };
  const alertsByShiftData = {
    categories: [
      "Production Floor",
      "Warehouse",
      "Loading Dock",
      "Office Area",
      "Maintenance Shop",
      "Storage Area",
    ],
    series: [
      {
        name: "Shift A",
        data: [1.5, 1, 1, 0.2, 1, 0.3],
      },
      {
        name: "Shift B",
        data: [1, 0.6, 1.5, 0.1, 1.1, 0.4],
      },
      {
        name: "Shift C",
        data: [0.5, 0.4, 0.2, 0.2, 0.7, 0.3],
      },
    ],
  };
  // Chart config for Total Alerts by Area
  const areaBarOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      background: "transparent",
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "55%",
      },
    },
    xaxis: {
      categories: totalareachart.categories,
      labels: {
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      labels: {
        style: { fontSize: "12px" },
      },
    },
    colors: ["#8b5cf6"],
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const areaData = apiData.areaWiseChart[dataPointIndex]?.areas || {};
        const areaEntries = Object.entries(areaData);

        if (areaEntries.length === 0) return "No area data";

        const areaList = areaEntries.map(([area, details]) => {
          return `${area}: ${details.total}`;
        }).join("<br/>");

        return `<div style="padding: 6px">
        <strong>Areas:</strong><br/>
        ${areaList}
      </div>`;
      },
    },
    dataLabels: {
      enabled: false,
      style: {
        fontSize: "12px",
        fontWeight: "400",           // Adjusted font weight
        colors: ["#FFFFFF"],         // Text color
        fontFamily: 'Poppins',       // Font family set to Poppins
      },
      background: {
        enabled: true, // Enable background for the data labels
        borderRadius: 15, // Rounded corners
        padding: 5, // Padding inside the label
        color: '#9c74f7', // Background color for labels (purple)
        opacity: 1, // Full opacity
      },
      formatter: function (val, { dataPointIndex, w }) {
        const xCoordinate = w.config.xaxis.categories[dataPointIndex]; // Get the x-coordinate (category)
        return `${xCoordinate}: ${val}`; // Format as "x-coordinate: value"
      },
      offsetY: function ({ dataPointIndex, w }) {
        const barHeight = w.config.series[0].data[dataPointIndex]; // Get the height of the bar
        return barHeight > 0 ? 10 : -10; // Adjust the value to make it appear slightly above
      },
      position: "top", // Position the label above each bar
      dropShadow: {
        enabled: false, // Optional: Remove shadow for clarity
      },
    },



  };


  const areaBarSeries = [
    {
      name: "Total Alerts",
      data: totalAlertsData.series,
    },
  ];

  // Chart config for Alerts by Area and Shift
  const areaShiftOptions = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
      background: "transparent",
    },
    xaxis: {
      categories: areashiftwise.categories,
      labels: {
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      labels: {
        style: { fontSize: "12px" },
      },
    },
    colors: ["#8b5cf6", "#10b981", "#f59e0b"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 4,
      },
    },
    legend: {
      position: "top",
    },
    dataLabels: {
      enabled: false
    }
  };

  const areaShiftSeries = alertsByShiftData.series;



  const modulePieData = {
    labels: ["Helmet", "Vest", "Emergency Exit", "MMHE"],
    series: [30.9, 20.5, 47.6, 0.9],
  };
  const shiftPieSeries = [33.3, 33.3, 33.4]; // Equal distribution across A, B, C
  const MODULE_COLORS = {
  Helmet: "#E58A00",          // orange
  Vest: "#2DA7FF",            // light blue
  "Emergency Exit": "#6F3ACB",// purple
  "Machine Guard": "#8B1E1E", // dark red
  MMHE: "#36B24A",            // green
  "No Go": "#1F4AA8",         // dark blue
};

 const modulePieOptions = {
  chart: {
    type: "pie",
    background: "transparent",
    width: "100%"
  },
  labels: moduleanalysis.labels,
  legend: {
    position: "right",
    fontSize: "12px"
  },
  dataLabels: {
    enabled: true,
    formatter: (val, opts) =>
      ` ${val.toFixed(1)}%`,
    style: {
      fontSize: "12px"
    },
    dropShadow: {
      enabled: false
    }
    // **No offset here**—offset for pie slices must go under plotOptions
  },
  plotOptions: {
    pie: {
      dataLabels: {
        offset: -10 // pulls the labels inside the slices
      },
       stroke: {
        show: false, // Hides white borders between slices
      },
    }
  },
   stroke: {
        show: false, // Hides white borders between slices
      },
  colors: ["#E58A00", "#2DA7FF", "#36B24A", "#6F3ACB", "#1F4AA8" ]
};



  const shiftPieOptions = {
    chart: {
      type: "pie",
      background: "transparent",
      width:'100%'
    },

    labels: ["Shift A", "Shift B", "Shift C"],
    legend: {
      show: true,
      position: 'top'
    },
     dataLabels: {
    enabled: true,
    // formatter: (val, opts) =>
    //   `${opts.w.globals.labels[opts.seriesIndex]}: ${val.toFixed(1)}%`,
    style: {
      fontSize: "12px"
    },
    dropShadow: {
      enabled: false
    }
    // **No offset here**—offset for pie slices must go under plotOptions
  },
     plotOptions: {
    pie: {
      dataLabels: {
        offset: -23 // pulls the labels inside the slices
      },
       stroke: {
        show: false, // Hides white borders between slices
      },
    }
  },
     stroke: {
        show: false, // Hides white borders between slices
      },
    colors: ["#8b5cf6", "#10b981", "#f59e0b"],
  };

  const shiftPieSeriess = [33.3, 33.3, 33.4];


  const complianceMetrics = [
    { zone: "Zone A1", compliance: 95, alerts: 8, label: "Excellent", color: "#dcfce7" },
    { zone: "Zone A2", compliance: 87, alerts: 15, label: "Good", color: "#e0f2fe" },
    { zone: "Zone B1", compliance: 92, alerts: 12, label: "Excellent", color: "#dcfce7" },
    { zone: "Zone B2", compliance: 78, alerts: 25, label: "Needs Improvement", color: "#fee2e2" },
    { zone: "Zone C1", compliance: 85, alerts: 18, label: "Good", color: "#e0f2fe" },
    { zone: "Zone C2", compliance: 90, alerts: 14, label: "Excellent", color: "#dcfce7" },
  ];

  const subAreaShiftSeries = [
    {
      name: "Shift A",
      data: [2, 3, 3, 4, 4, 3],
    },
    {
      name: "Shift B",
      data: [2, 2, 3, 3, 4, 2],
    },
    {
      name: "Shift C",
      data: [1, 2, 2, 3, 2, 2],
    },
  ];

  const subAreaShiftOptions = {
    chart: {
      type: "bar",
      stacked: true,


      background: "transparent",
      toolbar: { show: false },
    },
    grid: {
      padding: {
        left: 20,  // padding-inline start
        right: 20, // padding-inline end
        bottom: 50,
      },
    },
    xaxis: {
      categories: subareaanalysis.categories.map((name) => name.sub_area_name),
      labels: { style: { fontSize: "8px", height: '200px' }, },
    },
    yaxis: { labels: { style: { fontSize: "12px" } } },
    colors: ["#8b5cf6", "#10b981", "#f59e0b"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 4,
      },
    },
    legend: { position: "top" },
    dataLabels: {
      enabled: false
    }
  };
  const shiftAStats = {
    totalAlerts: 74,
    peakHour: "9AM",
    topArea: "Production",
    topModule: "Helmet",
  };

  const nearMissAreaData = {
    categories: [
      "Cold Store", "Mixing", "Production", "Outside Area", "Admin",
      "Outside Factory", "Contractors", "Dry Store", "Palletizing",
      "Electrical", "IT Room", "Biomass"
    ],
    series: [4, 5, 12, 3, 2, 6, 4, 3, 5, 1, 2, 1], // example values
  };
  const nearMissMonthlyData = {
    categories: ["January", "February", "March", "April"],
    series: [16, 22, 18, 21], // example values
  };
  const areaChartOptions = {
    chart: { type: "bar", toolbar: { show: false }, background: "transparent" },
    xaxis: {
      categories: nearMissAreaData.categories,
      labels: {
        rotate: -45,
        style: { fontSize: "10px" },
      },
    },
    yaxis: {
      labels: { style: { fontSize: "10px" } },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "40%",
      },
    },
    colors: ["#3b82f6"],
    grid: { padding: { bottom: 10 } },
  };

  const areaChartSeries = [
    { name: "Near Misses", data: nearMissAreaData.series },
  ];

  const monthlyChartOptions = {
    chart: { type: "line", toolbar: { show: false }, background: "transparent" },
    xaxis: {
      categories: nearMissMonthlyData.categories,
      labels: { style: { fontSize: "10px" } },
    },
    yaxis: {
      labels: { style: { fontSize: "10px" } },
    },
    stroke: { curve: "smooth", width: 2 },
    colors: ["#f59e0b"],
    grid: { padding: { bottom: 10 } },
  };

  const monthlyChartSeries = [
    { name: "Monthly Near Misses", data: nearMissMonthlyData.series },
  ];



  const openNearMissesSeries = [
    {
      name: "Open Near Misses",
      data: [3, 4, 2, 1, 3, 2, 3, 4, 1, 2],
    },
  ];
  const openNearMissesOptions = {
    chart: { type: "bar", toolbar: { show: false }, background: "transparent" },
    xaxis: {
      categories: [
        "Widen Admin", "Admin Mechanical", "Admin Electrical", "Fabrics Area",
        "Production", "Maintenance", "Store", "Dry Area", "Utility", "General",
      ],
      labels: { rotate: -45, style: { fontSize: "10px" } },
    },
    yaxis: { labels: { style: { fontSize: "10px" } } },
    colors: ["#3b82f6"],
  };


  const incidentActionSeries = [
    {
      name: "Open Actions",
      data: [2, 3, 1, 2, 1, 2, 1, 1],
    },
  ];
  const incidentActionOptions = {
    chart: { type: "bar", toolbar: { show: false }, background: "transparent" },
    xaxis: {
      categories: MOCData.ticketsAnalysis.categories,
      labels: { rotate: -45, style: { fontSize: "10px" } },
    },
    yaxis: { labels: { style: { fontSize: "10px" } } },
    colors: ["#22c55e"],
    dataLabels: {
      enabled: false
    }
  };


  const actionItems = [
    {
      number: "AC-INC-20230713-0016",
      category: "Incident",
      source: "Arc Flash - VFD Panel",
      description: "Evaluate Switchgear Control Logic...",
      responsible: "Rafay Usman",
      due: "30-Apr-25",
      remarks: "Overdue",
    },
    {
      number: "AC-INC-20230928-0068",
      category: "Incident",
      source: "Shift van hit a motorbike",
      description: "Complete ADMS System in all shift vans...",
      responsible: "Waseer Ahmad",
      due: "30-Apr-25",
      remarks: "Overdue",
    },
  ];

  const hazardsDeptSeries = [
    {
      name: "Hazards Logged",
      data: [1400, 1023, 865, 742, 560, 478, 321, 288, 244, 198, 165, 144, 120],
    },
  ];

  const hazardsDeptOptions = {
    chart: { type: "bar", background: "transparent", toolbar: { show: false } },
    xaxis: {
      categories: [
        "Production", "Engineering", "Warehouse", "Cold Storage", "Packing",
        "Utilities", "Maintenance", "QA", "Security", "Admin", "Waste Area",
        "Canteen", "Others"
      ],
      labels: {
        rotate: -45,
        style: { fontSize: "10px" },
      },
    },
    yaxis: {
      labels: {
        style: { fontSize: "10px" },
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "40%",
      },
    },
    colors: ["#3b82f6"],
  };

  const hazardsStatusSeries = [
    {
      name: "Open",
      data: [120, 102, 95, 88, 76, 54, 47, 33, 22, 15],
    },
    {
      name: "Closed",
      data: [380, 320, 290, 255, 230, 198, 165, 140, 110, 88],
    },
  ];

  const hazardsStatusOptions = {
    chart: { type: "bar", stacked: true, background: "transparent", toolbar: { show: false } },
    xaxis: {
      categories: MOCData.comparisonChart.categories,
      labels: {
        rotate: -45,
        style: { fontSize: "10px" },
      },
    },
    yaxis: {
      labels: { style: { fontSize: "10px" } },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 4,
      },
    },
    colors: ["#10b981", "#ef4444"],
    legend: {
      position: "top",
      labels: { colors: "#374151", fontSize: "12px" },
    },
    dataLabels: {
      enabled: false
    }
  };

  // KPI Cards
  const incidentStats = {
    total: 14,
    open: 6,
    overdue: 2,
  };
  const incidentCategorySeries = [
    {
      name: "Incidents",
      data: [3, 4, 5, 2], // e.g.
    },
  ];
  const incidentCategoryOptions = {
    chart: { type: "bar", background: "transparent", toolbar: { show: false } },
    xaxis: {
      categories: [
        "Road Safety (Vehicular)",
        "Fire Risk",
        "Fall Risk",
        "Compressed Gas",
      ],
      labels: { rotate: -45, style: { fontSize: "10px" } },
    },
    yaxis: { labels: { style: { fontSize: "10px" } } },
    colors: ["#3b82f6"],
  };
  const incidentMonthlySeries = [
    { name: "Incidents", data: [3, 2, 4, 3, 2] },
  ];
  const incidentMonthlyOptions = {
    chart: { type: "line", toolbar: { show: false }, background: "transparent" },
    xaxis: {
      categories: ["January", "February", "March", "April", "May"],
      labels: { style: { fontSize: "10px" } },
    },
    yaxis: { labels: { style: { fontSize: "10px" } } },
    stroke: { curve: "smooth", width: 2 },
    colors: ["#f97316"],
  };
  const openIncidentsSeries = [
    {
      name: "Open Incidents",
      data: [1, 2, 2, 1],
    },
  ];
  const openIncidentsOptions = {
    chart: { type: "bar", toolbar: { show: false }, background: "transparent" },
    xaxis: {
      categories: ["adil sultan", "Daniyal Ahmed", "Faizan Arshad", "usman tahir"],
      labels: { rotate: -45, style: { fontSize: "10px" } },
    },
    yaxis: { labels: { style: { fontSize: "10px" } } },
    colors: ["#f43f5e"],
  };
  const safetyKPIData = [
    {
      name: "Abbas Raza",
      dept: "Ops Manager",
      scFort: 0, scTarget: 2, scMTD: 0,
      smsFort: 0, smsTarget: 2, smsMTD: 0,
      dcaMTD: 0, dcaTarget: 1,
      jccMTD: 1, jccTarget: 1,
    },
    {
      name: "Moazzam Ali",
      dept: "Production",
      scFort: 0, scTarget: 2, scMTD: 0,
      smsFort: 0, smsTarget: 2, smsMTD: 0,
      dcaMTD: 0, dcaTarget: 1,
      jccMTD: 1, jccTarget: 1,
    },
    {
      name: "Pervez Akhtar",
      dept: "Mixing / CS",
      scFort: 1, scTarget: 2, scMTD: 50,
      smsFort: 0, smsTarget: 2, smsMTD: 0,
      dcaMTD: 0, dcaTarget: 1,
      jccMTD: 0, jccTarget: 1,
    },
  ];


  const shiftSummaries = [
    {
      name: "Shift B Analysis (2PM - 10PM)",
      subtitle: "Evening shift performance metrics",
      stats: {
        alerts: 59,
        peak: "7PM",
        area: "Production",
        module: "Helmet",
      },
      bg: "#ecfdf5", // green tone
      color: "#065f46",
    },
    {
      name: "Shift C Analysis (10PM - 6AM)",
      subtitle: "Night shift performance metrics",
      stats: {
        alerts: 44,
        peak: "11PM",
        area: "Production",
        module: "Helmet",
      },
      bg: "#fefce8", // yellow tone
      color: "#92400e",
    },
  ];


  const headerStyle = (bgColor) => ({
    backgroundColor: bgColor,
    color: "white",
    padding: "12px 8px", // Slightly more vertical padding
    textAlign: "center",
    fontWeight: 600,
    borderRight: "1px solid white",
    fontSize: "13px", // Slightly smaller font
  });

  const cellStyle = (bgColor, isLeft = false) => ({
    backgroundColor: bgColor,
    color: "white",
    padding: "8px 12px", // More horizontal padding
    textAlign: isLeft ? "left" : "center",
    fontWeight: isLeft ? 500 : 400,
    fontSize: "12px", // Slightly smaller font
  });

  const data = [
    {
      name: "Fatality/Class A",
      data: [0, 0, 0],
    },
    {
      name: "LTA",
      data: [1, 1, 0],
    },
    {
      name: "RWC",
      data: [0, 0, 0],
    },
    {
      name: "MTC",
      data: [0, 0, 0],
    },
    {
      name: "FAC",
      data: [15, 3, 5],
    },
    {
      name: "Near Miss",
      data: [144, 57, 68],
    },
    {
      name: "Hazards",
      data: [10065, 4352, 4217],
    },
    {
      name: "Alerts",
      data: [3346, 896, 1383],
    },
  ];

  const options = {
    chart: {
      type: "heatmap",
      toolbar: { show: false },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#fff"],
      },
    },
    xaxis: {
      categories: ["2024 FY", "2024 YTD", "2025 YTD"],
      labels: {
        style: {
          fontWeight: 600,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontWeight: 600,
        },
      },
    },
    plotOptions: {
      heatmap: {
        shadeIntensity: 0.5,
        radius: 4,
        useFillColorAsStroke: false,
        colorScale: {
          ranges: [
            { from: 0, to: 0, color: "#7f1d1d" },      // Fatality
            { from: 1, to: 1, color: "#be123c" },      // LTA
            { from: 2, to: 2, color: "#ef4444" },
            { from: 3, to: 10, color: "#f97316" },
            { from: 11, to: 100, color: "#fb923c" },
            { from: 101, to: 1000, color: "#facc15" },
            { from: 1001, to: 10000, color: "#eab308" },
            { from: 10001, to: 999999, color: "#fcd34d" },
          ],
        },
      },
    },
    title: {
      text: "Heinrich's Safety Pyramid Heatmap",
      align: "center",
      style: {
        fontSize: "18px",
        fontWeight: "bold",
      },
    },
  };



  const readable = new Date().toISOString()

  const datee = new Date(readable).toLocaleString("en-US", {
  weekday: "long",   // e.g. Monday
  year: "numeric",   // e.g. 2025
  month: "long",     // e.g. September
  day: "numeric",    // e.g. 5
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: true       // show AM/PM
});




  

  
  function DataSource({disrupt, shenet}) {
    return (
<div style={{backgroundColor:'#8d8e94', color:'white'}} className="d-flex align-items-center gap-2 p-1  rounded-3">
  <IoWarning />
  <div>{disrupt ? 'Disrupt Data Source' : shenet ? 'She Net Data Source' : 'She Net Data Source (Not Available Yet)'}</div>

      </div>
    )
  }



  // Generating Key Findings:


  const KeyFindings = () => {
    const keyFindings = generateKeyFindings();

    return (
      <div
        style={{
          marginTop: "16px",
          backgroundColor: "#f9fafb",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          padding: "16px",
        }}
      >
        <h4
          style={{
            fontSize: "1rem",
            fontWeight: "600",
            marginBottom: "8px",
            color: "#111827",
          }}
        >
          Key Findings:
        </h4>
        <ul style={{ margin: "0", paddingLeft: "20px", color: "#374151", fontSize: "14px" }}>
          {
            keyFindings ? (
              keyFindings.map((finding, index) => (
                <li key={index}>{finding}</li>
              ))
            ) : (
              <>
                <div className="d-flex align-items-center gap-2">
                  <IoWarning />
                  <div>Not Available</div>
                </div>
              </>
            )
          }
        </ul>
      </div>
    );
  };


// helpers
const DAY_ORDER = ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"];
const cap = s => s.charAt(0).toUpperCase() + s.slice(1);

// build a dynamic config for keys + labels + colors + data accessor
const cardConfig = (() => {
  // MONTH → use week_analysis: week_1 ... week_6
  if (filters?.month !== '') {
    const wa = apiData?.shiftAnalysis?.data?.week_analysis || {};
    const keys = Object.keys(wa).sort(
      (a,b) => parseInt(a.split("_")[1],10) - parseInt(b.split("_")[1],10)
    );

    // palette for up to 6 weeks
    const WEEK_COLORS = ["#2563eb","#059669","#d97706","#7c3aed","#dc2626","#0ea5e9"];
    const WEEK_BGS    = ["#eff6ff","#ecfdf5","#fff7ed","#f5f3ff","#fee2e2","#e0f2fe"];

    const nameMap  = Object.fromEntries(keys.map((k,i) => [k, `Week ${parseInt(k.split("_")[1],10)}`]));
    const colorMap = Object.fromEntries(keys.map((k,i) => [k, WEEK_COLORS[i % WEEK_COLORS.length]]));
    const bgMap    = Object.fromEntries(keys.map((k,i) => [k, WEEK_BGS[i % WEEK_BGS.length]]));

    const getData = (k) => wa?.[k];

    return { keys, nameMap, colorMap, bgMap, getData };
  }

  // WEEK → use day_analysis: monday ... sunday (sorted Mon→Sun)
  if (filters?.week !== '') {
    const da = apiData?.shiftAnalysis?.data?.day_analysis || {};
    const keys = Object.keys(da)
      .filter(Boolean)
      .sort((a,b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b));

    const DAY_COLORS = ["#2563eb","#059669","#d97706","#7c3aed","#dc2626","#0ea5e9","#16a34a"];
    const DAY_BGS    = ["#eff6ff","#ecfdf5","#fff7ed","#f5f3ff","#fee2e2","#e0f2fe","#ecfdf5"];

    const nameMap  = Object.fromEntries(keys.map((k,i) => [k, cap(k)]));
    const colorMap = Object.fromEntries(keys.map((k,i) => [k, DAY_COLORS[i % DAY_COLORS.length]]));
    const bgMap    = Object.fromEntries(keys.map((k,i) => [k, DAY_BGS[i % DAY_BGS.length]]));

    const getData = (k) => da?.[k];

    return { keys, nameMap, colorMap, bgMap, getData };
  }

  // DATE (default) → use shift_analysis: shift_a / shift_b / shift_c
  const sa = apiData?.shiftAnalysis?.data?.shift_analysis || {};
  const keys = ["shift_a","shift_b","shift_c"];
  const nameMap = { shift_a: "Shift A", shift_b: "Shift B", shift_c: "Shift C" };
  const colorMap = { shift_a: "#2563eb", shift_b: "#059669", shift_c: "#d97706" };
  const bgMap    = { shift_a: "#eff6ff", shift_b: "#ecfdf5", shift_c: "#fff7ed" };

  const getData = (k) => sa?.[k];

  return { keys, nameMap, colorMap, bgMap, getData };
})();






  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
        padding: "14px",
        maxWidth: '1000px'
      }}
      id="report-page"
    >
      <div
        style={{

          margin: "0 auto",
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "24px",
            borderBottom: "1px solid #e5e7eb",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: "2.25rem",
              fontWeight: "bold",
              color: "#111827",
              margin: "0 0 8px 0",
            }}
          >
            {filters.week !== '' ? 'Weekly' : filters.date !== '' ? 'Daily' : filters.month !== '' && 'Monthly'} Safety Report - {filters.week !== '' ? filters.week : filters.date !== '' ? filters.date : filters.month !== '' && filters.month}
          </h1>
          <p style={{ color: "#6b7280", margin: "0 0 12px 0" }}>
          {factoryName} Comprehensive {filters.date !== '' ? '24-Hour ' : filters.week !== '' ? 'Day to Day' : 'Weeks'}Analysis of Safety Performance
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              fontSize: "14px",
              color: "#6b7280",
            }}
          >
            {/* <span>📅 Report Date: June 16, 2025</span> */}
            <span>• Coverage: {filters.week !== '' ? 'Whole Week' : filters.date !== '' ? '24 Hour' : 'Whole Month'}</span>
            <span>• Generated on {datee}</span>
          </div>
        </div>


        <div style={{ padding: "14px" }}>
          {/* Executive Summary */}
          <div style={{ marginBottom: "32px" }}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h2
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "600",
                  borderLeft: "4px solid #3b82f6",
                  paddingLeft: "12px",
                  marginBottom: "20px",
                }}
              >
                Executive Summary
              </h2>
              <DataSource disrupt={true} />
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: 'space-evenly'


              }}
            >
              {/* Card 1 */}
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{
                  backgroundColor: "#fef2f2",
                  border: "1px solid #fecaca",
                  borderRadius: "8px",
                  padding: "16px",
                  // textAlign: "center",
                  width: "220px",
                }}
              >
                <IoWarningOutline size={24} color="#dc2626" />
                <h3
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "#dc2626",
                    margin: "8px 0 0",
                  }}
                >
                  {apiData.executiveSummary.totalAlerts}
                </h3>
                <p style={{ color: "#b91c1c", fontSize: "14px", margin: "0" }}>
                  Total Alerts 
                </p>
              </div>

              {/* Card 2 */}
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{
                  backgroundColor: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  borderRadius: "8px",
                  padding: "16px",
                  // textAlign: "center",
                  width: "220px",
                }}
              >
                <FaArrowTrendUp size={24} color="#16a34a" />
                <h3
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "#16a34a",
                    margin: "8px 0 0",
                  }}
                >
                  {apiData?.executiveSummary?.avgCompliance}
                </h3>
                <p style={{ color: "#15803d", fontSize: "14px", margin: "0" }}>
                  Avg Compliance
                </p>
              </div>

              {/* Card 3 */}
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{
                  backgroundColor: "#eff6ff",
                  border: "1px solid #bfdbfe",
                  borderRadius: "8px",
                  padding: "16px",
                  // textAlign: "center",
                  width: "220px",
                }}
              >
                <MdOutlineWatchLater size={24} color="#2563eb" />
                <h5
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "#2563eb",
                    margin: "8px 0 0",
                  }}
                >
                  {apiData?.executiveSummary?.peakAlerts!=='' ? apiData?.executiveSummary?.peakAlerts : 'N/A'}
                </h5>
                <p style={{ color: "#1d4ed8", fontSize: "14px", margin: "0" }}>
                  Peak Alerts Time
                </p>
              </div>

              {/* Card 4 */}
              <div
              className="d-flex flex-column justify-content-center align-items-evenly"
                style={{
                  backgroundColor: "#faf5ff",
                  border: "1px solid #d8b4fe",
                  borderRadius: "8px",
                  padding: "16px",
                  // textAlign: "center",
                  width: "220px",
                }}
              >
                <BiMap size={24} color="#8b5cf6" />
                <h4
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "#8b5cf6",
                    // margin: "8px 0 0",
                  }}
                >
                  {apiData?.executiveSummary?.highRiskArea!=='' ? apiData?.executiveSummary?.highRiskArea : 'N/A'}
                </h4>
                <p style={{ color: "#8b5cf6", fontSize: "12px", margin: "0" }}>
                  High Risk Area
                </p>
              </div>
            </div>
          </div>


          {/* Heinrich's Safety Pyramid */}
          <div style={{ marginBottom: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
            <h2
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                borderLeft: "4px solid #dc2626",
                paddingLeft: "12px",
                margin: "0 0 16px 0",
              }}
            >
              Heinrich's Safety Pyramid
            </h2>
            <DataSource disrupt={false} shenet={false} />
            </div>

            <div
              style={{
                backgroundColor: "white",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "24px",
              }}
            >
              <div style={{ marginBottom: "16px" }}>
                <h3 style={{ fontSize: "1.125rem", fontWeight: "600", margin: "0 0 4px 0" }}>
                  Safety Performance Hierarchy
                </h3>
                <p style={{ color: "#6b7280", fontSize: "14px", margin: "0" }}>
                  Incident classification following Heinrich's pyramid model
                </p>
              </div>

              <div style={{ display: "flex", gap: "24px", alignItems: "flex-start" }}>
                {/* Pyramid Visual */}
                <div style={{ flexShrink: 0 }}>
                  <div
                    style={{

                      borderRadius: "8px",

                      textAlign: "center",
                    }}
                  >
                    <h5 style={{
                      fontWeight: "600", marginBottom: "12px", color: "#7f1d1d", backgroundColor: "#fef2f2",
                      padding: "10px", border: "2px solid #dc2626", borderRadius: "4px", marginBottom: '20px'
                    }}>
                      H-Pyramid
                    </h5>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                      {pyramidData.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            backgroundColor: item.color,
                            color: "#fff",
                            fontSize: "12px",
                            padding: "10px 8px",

                            width: `${100 + index * 10}px`,
                            textAlign: "center",
                          }}
                        >
                          {item.level}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Grid Table */}
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, 1fr)",
                      gap: "8px",
                    }}
                  >
                    {/* Headers */}
                    {["Category", "2024 FY", "2024 YTD", "2025 YTD"].map((header, i) => (
                      <div
                        key={`head-${i}`}
                        style={{
                          backgroundColor: "#dc2626",
                          color: "#fff",
                          padding: "12px",
                          fontWeight: "600",
                          textAlign: "center",

                        }}
                      >
                        {header}
                      </div>
                    ))}

                    {/* Data Rows */}
                    {pyramidData.map((item, rowIndex) => (
                      <>
                        <div
                          key={`cat-${rowIndex}`}
                          style={{
                            backgroundColor: item.color,
                            color: "#fff",
                            padding: "12px",
                            textAlign: "center",

                            fontWeight: "500",
                          }}
                        >
                          {item.level}
                        </div>
                        {[item.fy2024, item.ytd2024, item.ytd2025].map((val, i) => (
                          <div
                            key={`val-${rowIndex}-${i}`}
                            style={{
                              backgroundColor: item.color,
                              color: "#fff",
                              padding: "12px",
                              textAlign: "center",

                              fontWeight: "500",
                            }}
                          >
                            {val.toLocaleString()}
                          </div>
                        ))}
                      </>
                    ))}
                  </div>
                </div>
              </div>

            </div>
          </div>


          {/* Time-Based Alert Analysis */}
          <div>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h2
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "600",
                  marginBottom: "16px",
                  borderLeft: "4px solid #3b82f6",
                  paddingLeft: "12px",
                  margin: "0 0 16px 0",
                }}
              >
                ⏰ Time-Based Alerts Analysis
              </h2>
              <DataSource disrupt={true} />
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(500px, 1fr))",
                gap: "24px",
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  padding: "24px",
                }}
              >
                <div style={{ marginBottom: "12px" }}>
                  <h3
                    style={{
                      fontSize: "1.125rem",
                      fontWeight: "600",
                      margin: "0 0 4px 0",
                    }}
                  >
                    Alerts Distribution Trend
                  </h3>
                  <p
                    style={{
                      color: "#6b7280",
                      fontSize: "14px",
                      margin: "0",
                    }}
                  >
                   {filters?.week!=='' ? 'Daily' : filters?.date!=='' ? 'Hourly' : 'Weekly'} breakdown of Alerts across the entire day
                  </p>
                </div>

                <Chart
                  //  key={isPdfRendering ? "pdf-mode-chart" : "live-mode-chart"}

                  options={lineChartOptions}
                  series={lineChartSeries}
                  type="line"
                  height={200}
                />



              </div>

              <div
                style={{
                  backgroundColor: "white",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  padding: "24px",
                }}
              >
                <div style={{ marginBottom: "12px" }}>
                  <h3
                    style={{
                      fontSize: "1.125rem",
                      fontWeight: "600",
                      margin: "0 0 4px 0",
                    }}
                  >
                    Shift-Based Comparison
                  </h3>
                  <p
                    style={{
                      color: "#6b7280",
                      fontSize: "14px",
                      margin: "0",
                    }}
                  >
                    Alerts patterns across three 8-hour shifts
                  </p>
                </div>

                <Chart
                  //  key={'xyz'}
                  options={shiftChartOptions}
                  series={shiftcomparison.data}
                  type="line"
                  height={300}
                />


              </div>
            </div>
          </div>
          {/* Area-Based Alert Analysis */}
          <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2" >
              <h2
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "600",
                  marginBottom: "16px",
                  borderLeft: "4px solid #10b981",
                  paddingLeft: "12px",
                  margin: "0 0 16px 0",
                }}
              >
                📍 Area-Based Alerts Analysis
              </h2>
              <DataSource disrupt={true} />
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                gap: "24px",
              }}
            >
              {/* Chart 1: Total Alerts by Area */}
              <div
                style={{
                  backgroundColor: "white",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  padding: "24px",
                }}
              >
                <h3 style={{ fontSize: "1.125rem", fontWeight: "600", marginBottom: "8px" }}>
                  Total Alerts by Area
                </h3>
                {Array.isArray(totalareachart?.data) && totalareachart?.data.length > 0 &&
                  Array.isArray(totalareachart?.categories) && totalareachart?.categories.length > 0 ? (
                  <Chart options={areaBarOptions} series={totalareachart.data} type="bar" height={300} />
                ) : (
                  'Data Not Available'
                )}
              </div>

              {/* Chart 2: Alerts by Area and Shift */}
              <div
                style={{
                  backgroundColor: "white",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  padding: "24px",
                }}
              >
                <h3 style={{ fontSize: "1.125rem", fontWeight: "600", marginBottom: "8px" }}>
                  Alerts by Area and Shift
                </h3>
                {Array.isArray(areashiftwise?.data) && areashiftwise?.data.length > 0 &&
                  Array.isArray(areashiftwise?.categories) && areashiftwise?.categories.length > 0 ? (
                  <Chart options={areaShiftOptions} series={areashiftwise.data} type="bar" height={300} />
                ) : (
                  'Data Not Available'
                )}

              </div>
            </div>

            {/* Key Findingsesss */}
         
            <KeyFindings />
          </div>
          {/* Module-Based Alert Analysis */}
          <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2" >
              <h2
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "600",
                  marginBottom: "16px",
                  borderLeft: "4px solid #f97316",
                  paddingLeft: "12px",
                  margin: "0 0 16px 0",
                }}
              >
                ⚙️ Module-Based Alerts Analysis
              </h2>
              <DataSource disrupt={true} />
            </div>
            <div
              style={{
                backgroundColor: "white",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "24px",
                marginBottom: "24px",
              }}
            >
              <h3 style={{ fontSize: "1.125rem", fontWeight: "600", marginBottom: "8px" }}>
                Overall Module Distribution
              </h3>
              <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "16px" }}>
                Total Alerts by safety module type
              </p>

              {moduleanalysis.series.every(value => value === 0) ? (
                <p style={{ fontSize: "14px", fontWeight: "500", color: "#9c74f7" }}>
                  No Alerts in All Modules
                </p>
              ) : (
                <>
                <Chart options={modulePieOptions} series={moduleanalysis.series} type="pie" height={300} />
                </>
              )}
            </div>


         <div
  style={{
    // display: "grid",
    // gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    // gap: "16px",
    display: 'flex'
  }}
>
   <div  style={{ padding: "20px" }}>
    {Object.entries(modulebyshift || {}).map(([category, days]) => 
    {
      const moduleColor = MODULE_COLORS[category] || "#888";
   return (
      <div key={category} style={{ marginBottom: "28px" }}>
        <h3 style={{ marginBottom: "16px" }}>{category} Alerts by Day</h3>
        <div
          className="d-flex flex-wrap align-items-center justify-content-center gap-3"
          // style={{
          //   display: "grid",
          //   gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          //   gap: "16px",
          // }}
        >
          {days?.map((d) => (
            <div
              key={d.dayKey}
              className="d-flex align-items-center justify-content-center flex-column"
            
              style={{
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "12px",
                background: "#fff",
                height:'300px',
                width:'270px'
              }}
            >
   

{
  d.count==0 ? (
    <>
    <div>
     No Alerts on {d.dayLabel}
      </div>
    </>
  ) : (
    <>
    
<Chart
  options={{
    ...pieOptions(d.dayLabel, d.percentage),
    // force slice colors: [module slice, rest-of-day slice]
    colors: [moduleColor,  '#5e5f60'],        // neutral gray for the second slice
    fill:   { colors: [moduleColor, '#5e5f60'] },
  }}
  series={[d.count, Math.max((d.total || 0) - d.count, 0)]}

  type="pie"
  width={250}
  height={250}
/>
    </>
  )
}

            {
              d.count==0 ? (
                <div className="d-flex align-items-center gap-1 mt-3">
                  <CgCheckO style={{fontSize:'16px', color:'green'}} />
                  <p style={{fontSize:'16px', fontWeight:'700'}} className="p-0 m-0">100% Compliance</p> 
                </div>
              ) : (

              <div
                style={{
                  textAlign: "center",
                  marginTop: "8px",
                  fontSize: "15px",
                  color: "#555",
                }}
              >
                <strong>{d.count}</strong> Alerts 
              </div>
              )
            }
            </div>
          ))}
        </div>
      </div>
    )
  }
    
    )}
  </div>

</div>

          </div>
          {/* Compliance Analysis by Sub-Area */}
          <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h2
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "600",
                  marginBottom: "16px",
                  borderLeft: "4px solid #8b5cf6",
                  paddingLeft: "12px",
                  margin: "0 0 16px 0",
                }}
              >
                🧭 Compliance Analysis by Sub-Area
              </h2>
              <DataSource disrupt={true} />
            </div>
            <div
            // style={{
            //   display: "grid",
            //   gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
            //   gap: "24px",
            // }}
            >
              {/* Compliance Metrics */}
              <div>
                <h3 style={{ fontSize: "1.125rem", fontWeight: "600", marginBottom: "12px" }}>
                  Sub-Area Compliance Metrics
                </h3>
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  {subareamatrics
  .slice() // make a copy so original array isn’t mutated
  .sort((a, b) => a.overall_compliance_percentage - b.overall_compliance_percentage).map((zone, idx) => (
                    <div
                      key={idx}
                      style={{
                        backgroundColor: idx % 2 == 0 ? '#dcfce7' : '#e0f2fe',
                        padding: "12px 16px",
                        borderRadius: "8px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "14px",
                        border: "1px solid #e5e7eb",
                      }}
                    >
                      <div>
                        <strong>{zone.sub_area_name}</strong>
                        <div>Compliance: {zone.overall_compliance_percentage}%</div>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontWeight: "600" }}>{zone.overall_compliance_status}</div>
                        <div style={{ color: "#4b5563" }}>Alerts: {zone.total_non_compliance_events}</div>
                      </div>
                    </div>
                  ))} 
                </div>
              </div>

              {/* Chart */}
              <div  className='mt-4 '>
                <div className="d-flex align-items-center justify-content-between">
                <h3 style={{ fontSize: "1.125rem", fontWeight: "600" }}>
                  Sub-Area Alerts by Shift
                </h3>
                <DataSource disrupt={true} />
                </div>
               {Array.isArray(subareaanalysis?.data) && subareaanalysis?.data.length > 0 ? (
  <Chart options={subAreaShiftOptions} series={subareaanalysis.data} type="bar" height={400} />
) : (
  'Data Not Available'
)}

              </div>
            </div>
          </div>
          {/* Shift B & C Analysis */}
          <div className="d-flex align-items-center justify-content-between  mb-2">
            <h3 style={{ fontSize: "1.125rem", fontWeight: "600" }}>
                {
                  filters?.date ? (
                    <>
                    Shift-Based Analysis
                    </>
                  ) : filters?.week ? (
                    <>
                    Weekly-Based Analysis
                    </>
                  ) : (
                    <>
                    Monthly-Based Analysis
                    </>
                  )
                }
            </h3>
            <DataSource disrupt={true} shenet={false} />
          
          </div>
          <div >
        {cardConfig.keys.map((key, i) => {
  const data = cardConfig.getData(key);

  const shift = {
    name:  cardConfig.nameMap[key],
    color: cardConfig.colorMap[key],
    bg:    cardConfig.bgMap[key],
    stats: {
      alerts: data?.total_alerts ?? "-",
      peak:   data?.peak_hour ?? "-",
      area:   data?.top_area ?? "-",
      module: data?.top_module ?? "-",
    }
  };

  return (
    // ⬇️ your existing card JSX unchanged
    <div
      key={i}
      style={{
        backgroundColor: shift.bg,
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        padding: "24px",
        marginBottom: "16px",
      }}
    >
      <p style={{ fontWeight: "600", fontSize: "16px", color: shift.color, marginBottom: "0px" }}>
        {shift.name}
      </p>
      <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "16px", marginTop:'0px' }}>
        Shift performance matrix
      </p>

      <div className="d-flex align-items-center justify-content-evenly">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: shift.color, margin: 0 }}>
            {shift.stats.alerts}
          </h3>
          <p style={{ fontSize: "14px", color: shift.color, margin: 0 }}>Total Alerts </p>
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center">
          <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: shift.color, margin: 0 }}>
            {shift.stats.peak}
          </h3>
          <p style={{ fontSize: "14px", color: shift.color, margin: 0 }}>Peak Hour</p>
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center">
          <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: shift.color, margin: 0 }}>
            {shift.stats.area}
          </h3>
          <p style={{ fontSize: "14px", color: shift.color, margin: 0 }}>Top Area</p>
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center">
          <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: shift.color, margin: 0 }}>
            {shift.stats.module}
          </h3>
          <p style={{ fontSize: "14px", color: shift.color, margin: 0 }}>Top Module</p>
        </div>
      </div>
    </div>
  );
})}


          </div>

            {/* MOC Open tickets */}
                <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
            <h2
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                marginBottom: "16px",
                borderLeft: "4px solid #3b82f6",
                paddingLeft: "12px",
                color: "#1d4ed8",
              }}
            >
              🧾MOC Open Tickets
            </h2>
            <DataSource disrupt={false} shenet={true} />
            </div>

            {/* KPI Cards */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                gap: "16px",
                marginBottom: "24px",
              }}
            >
              <div style={{ backgroundColor: "#dcfce7", padding: "16px", textAlign: "center", borderRadius: "8px" }}>
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#15803d", margin: 0 }}>{MOCData.ticketCards.closure_rate}%</h3>
                <p style={{ fontSize: "14px", color: "#15803d", margin: 0 }}>Closure Rate</p>
              </div>
              <div style={{ backgroundColor: "#dbeafe", padding: "16px", textAlign: "center", borderRadius: "8px" }}>
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#1d4ed8", margin: 0 }}>{MOCData.ticketCards.open_tickets}</h3>
                <p style={{ fontSize: "14px", color: "#1d4ed8", margin: 0 }}>Open Tickets</p>
              </div>
              <div style={{ backgroundColor: "#fee2e2", padding: "16px", textAlign: "center", borderRadius: "8px" }}>
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#b91c1c", margin: 0 }}>{MOCData.ticketCards.over_due_tickets}</h3>
                <p style={{ fontSize: "14px", color: "#b91c1c", margin: 0 }}>Overdue Tickets</p>
              </div>
            </div>

            {/* MOC Actions Chart */}
            <div
              style={{
                backgroundColor: "white",
                border: "2px solid #86efac",
                borderRadius: "8px",
                padding: "16px",
                overflowX: "auto",
              }}
            >
              <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#16a34a", marginBottom: "8px" }}>
               MOC Tickets Analysis
              </h3>
              <Chart options={incidentActionOptions} series={MOCData.ticketsAnalysis.series} type="bar" height={300} />
            </div>
             <div
              style={{
                backgroundColor: "white",
                border: "2px solid #facc15",
                borderRadius: "8px",
                padding: "16px",
                overflowX: "auto",
                marginTop:'20px'
              }}
            >
              <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#1d4ed8", marginBottom: "8px" }}>
                Due vs Overdue Tickets Comparsion
              </h3>
              <Chart options={hazardsStatusOptions} series={MOCData.comparisonChart.series} type="bar" height={300} />
            </div>
          </div>
            <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
            <h3 style={{ fontSize: "1.125rem", fontWeight: "600", marginBottom: "12px" }}>
              📝 Ticket Items Details
            </h3>
            <DataSource disrupt={false} shenet={true} />
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                <thead style={{ backgroundColor: "#f3f4f6" }}>
                  <tr>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Ticket Number</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Source Category</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Source</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Satus</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Person Responsible</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Due Date</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {MOCData.ticketItems.map((item, i) => (
                    <tr key={i}>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.ticket_no}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.source_category}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.source}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.status}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.person_resp}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.due_date}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb", color: item.remarks=='Overdue' ? "#b91c1c" : item.remarks=='Closed' ? '#30c595' : '#c4952f', fontWeight: "600" }}>
                        {item.remarks}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Individual Shift Analysis */}
          {/* <div style={{ marginTop: "32px" }}>
  <h2
    style={{
      fontSize: "1.25rem",
      fontWeight: "600",
      marginBottom: "16px",
      borderLeft: "4px solid #3b82f6",
      paddingLeft: "12px",
      margin: "0 0 16px 0",
    }}
  >
    👤 Individual Shift Analysis
  </h2>

  <div
    style={{
      backgroundColor: "#f0f9ff",
      border: "1px solid #c7d2fe",
      borderRadius: "8px",
      padding: "24px",
    }}
  >
    <p style={{ fontWeight: "600", fontSize: "16px", color: "#1e3a8a", marginBottom: "4px" }}>
      Shift A Analysis (6AM – 2PM)
    </p>
    <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "16px" }}>
      Day shift performance metrics
    </p>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
        gap: "16px",
        textAlign: "center",
      }}
    >
      <div>
        <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#1e40af", margin: 0 }}>
          {shiftAStats.totalAlerts}
        </h3>
        <p style={{ fontSize: "14px", color: "#1e3a8a", margin: 0 }}>Total Alerts</p>
      </div>
      <div>
        <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#1e40af", margin: 0 }}>
          {shiftAStats.peakHour}
        </h3>
        <p style={{ fontSize: "14px", color: "#1e3a8a", margin: 0 }}>Peak Hour</p>
      </div>
      <div>
        <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#1e40af", margin: 0 }}>
          {shiftAStats.topArea}
        </h3>
        <p style={{ fontSize: "14px", color: "#1e3a8a", margin: 0 }}>Top Area</p>
      </div>
      <div>
        <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#1e40af", margin: 0 }}>
          {shiftAStats.topModule}
        </h3>
        <p style={{ fontSize: "14px", color: "#1e3a8a", margin: 0 }}>Top Module</p>
      </div>
    </div>
  </div>
</div> */}
          {/* Near-Miss Analysis YTD 2025 */}
          <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
            <h2
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                marginBottom: "16px",
                borderLeft: "4px solid #3b82f6",
                paddingLeft: "12px",
                color: "#1d4ed8",
              }}
            >
              📘 Near-Miss Analysis YTD 2025
            </h2>
            <DataSource disrupt={false} shenet={false} />
              </div>
            {/* KPI Summary */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                gap: "16px",
                marginBottom: "24px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#fee2e2",
                  borderRadius: "8px",
                  padding: "16px",
                  textAlign: "center",
                }}
              >
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#b91c1c", margin: 0 }}>3</h3>
                <p style={{ fontSize: "14px", color: "#b91c1c", margin: 0 }}>Overdue</p>
              </div>
              <div
                style={{
                  backgroundColor: "#dbeafe",
                  borderRadius: "8px",
                  padding: "16px",
                  textAlign: "center",
                }}
              >
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#1d4ed8", margin: 0 }}>77</h3>
                <p style={{ fontSize: "14px", color: "#1d4ed8", margin: 0 }}>Total Near Misses</p>
              </div>
              <div
                style={{
                  backgroundColor: "#fef3c7",
                  borderRadius: "8px",
                  padding: "16px",
                  textAlign: "center",
                }}
              >
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#b45309", margin: 0 }}>25</h3>
                <p style={{ fontSize: "14px", color: "#b45309", margin: 0 }}>Open Near-misses</p>
              </div>
            </div>

            {/* Charts */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
                gap: "24px",
              }}
            >
              {/* Area Chart */}
              <div
                style={{
                  backgroundColor: "#fff",
                  border: "2px solid #facc15",
                  borderRadius: "8px",
                  padding: "16px",
                  overflow: "hidden",
                }}
              >
                <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#1d4ed8", marginBottom: "8px" }}>
                  Area Wise Near Misses Spread YTD 2025
                </h3>
                <div style={{ width: "100%", overflowX: "auto" }}>
                  <Chart options={areaChartOptions} series={areaChartSeries} type="bar" height={300} />
                </div>
              </div>

              {/* Monthly Chart */}
              <div
                style={{
                  backgroundColor: "#fff",
                  border: "2px solid #facc15",
                  borderRadius: "8px",
                  padding: "16px",
                  overflow: "hidden",
                }}
              >
                <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#1d4ed8", marginBottom: "8px" }}>
                  Near Misses Insights YTD 2025
                </h3>
                <Chart options={monthlyChartOptions} series={monthlyChartSeries} type="line" height={300} />
              </div>
            </div>
          </div>

          {/* Open Near Misses Responsibility Wise */}
          <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
            <h3
              style={{
                fontSize: "1rem",
                fontWeight: "600",
                color: "#1d4ed8",
                marginBottom: "8px",
              }}
            >
              📊 Open Near Misses Responsibility Wise YTD 2025 (25)
            </h3>
            <DataSource disrupt={false} shenet={false} />
            </div>
            <div
              style={{
                backgroundColor: "white",
                border: "2px solid #facc15",
                borderRadius: "8px",
                padding: "16px",
                overflowX: "auto",
              }}
            >
              <Chart options={openNearMissesOptions} series={openNearMissesSeries} type="bar" height={300} />
            </div>
          </div>

          {/* Incident Action Items Analysis */}
          <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
            <h2
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                marginBottom: "16px",
                borderLeft: "4px solid #3b82f6",
                paddingLeft: "12px",
                color: "#1d4ed8",
              }}
            >
              🧾 Incidents Action Items Analysis YTD 2025
            </h2>
            <DataSource disrupt={false} shenet={false} />
            </div>

            {/* KPI Cards */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                gap: "16px",
                marginBottom: "24px",
              }}
            >
              <div style={{ backgroundColor: "#dcfce7", padding: "16px", textAlign: "center", borderRadius: "8px" }}>
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#15803d", margin: 0 }}>69%</h3>
                <p style={{ fontSize: "14px", color: "#15803d", margin: 0 }}>Closure Rate</p>
              </div>
              <div style={{ backgroundColor: "#dbeafe", padding: "16px", textAlign: "center", borderRadius: "8px" }}>
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#1d4ed8", margin: 0 }}>13</h3>
                <p style={{ fontSize: "14px", color: "#1d4ed8", margin: 0 }}>Open Action Items</p>
              </div>
              <div style={{ backgroundColor: "#fee2e2", padding: "16px", textAlign: "center", borderRadius: "8px" }}>
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#b91c1c", margin: 0 }}>2</h3>
                <p style={{ fontSize: "14px", color: "#b91c1c", margin: 0 }}>Overdue Action Items</p>
              </div>
            </div>

            {/* Incident Actions Chart */}
            <div
              style={{
                backgroundColor: "white",
                border: "2px solid #86efac",
                borderRadius: "8px",
                padding: "16px",
                overflowX: "auto",
              }}
            >
              <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#16a34a", marginBottom: "8px" }}>
                Incident Actions (13 Open Actions)
              </h3>
              <Chart options={incidentActionOptions} series={incidentActionSeries} type="bar" height={300} />
            </div>
          </div>

        
          {/* Action Items Details Table */}
          <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
            <h3 style={{ fontSize: "1.125rem", fontWeight: "600", marginBottom: "12px" }}>
              📝 Action Items Details
            </h3>
            <DataSource disrupt={false} shenet={false} />
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                <thead style={{ backgroundColor: "#f3f4f6" }}>
                  <tr>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Action Number</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Source Category</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Source</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Description</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Person Responsible</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Due Date</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {actionItems.map((item, i) => (
                    <tr key={i}>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.number}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.category}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.source}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.description}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.responsible}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>{item.due}</td>
                      <td style={{ padding: "8px", border: "1px solid #e5e7eb", color: "#b91c1c", fontWeight: "600" }}>
                        {item.remarks}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Hazards Analysis YTD 2025 */}
          <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
            <h2
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                marginBottom: "16px",
                borderLeft: "4px solid #3b82f6",
                paddingLeft: "12px",
                color: "#1d4ed8",
              }}
            >
              🧯 Hazards Analysis YTD 2025
            </h2>
            <DataSource disrupt={false} shenet={false} />
              </div>
            {/* Chart 1: Department-Wise Hazards */}
            <div
              style={{
                backgroundColor: "white",
                border: "2px solid #facc15",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "24px",
                overflowX: "auto",
              }}
            >
              <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#1d4ed8", marginBottom: "8px" }}>
                Department Wise Hazards Log Spread (Total)
              </h3>
              <Chart options={hazardsDeptOptions} series={hazardsDeptSeries} type="bar" height={300} />
            </div>

            {/* Chart 2: Responsibility Wise Open vs Closed */}
            <div
              style={{
                backgroundColor: "white",
                border: "2px solid #facc15",
                borderRadius: "8px",
                padding: "16px",
                overflowX: "auto",
              }}
            >
              <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#1d4ed8", marginBottom: "8px" }}>
                Open vs Closed Hazards Responsibility wise (2025 Log)
              </h3>
              <Chart options={hazardsStatusOptions} series={hazardsStatusSeries} type="bar" height={300} />
            </div>
          </div>

          {/* Incidents Analysis YTD 2025 */}
          <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
            <h2
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                marginBottom: "16px",
                borderLeft: "4px solid #3b82f6",
                paddingLeft: "12px",
                color: "#1d4ed8",
              }}
            >
              🚨 Incidents Analysis YTD 2025
            </h2>
            <DataSource disrupt={false} shenet={false} />
              </div>
            {/* KPI Cards */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                gap: "16px",
                marginBottom: "24px",
              }}
            >
              <div style={{ backgroundColor: "#fee2e2", padding: "16px", borderRadius: "8px", textAlign: "center" }}>
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#b91c1c", margin: 0 }}>
                  {incidentStats.overdue}
                </h3>
                <p style={{ fontSize: "14px", color: "#b91c1c", margin: 0 }}>Overdue</p>
              </div>
              <div style={{ backgroundColor: "#dbeafe", padding: "16px", borderRadius: "8px", textAlign: "center" }}>
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#1d4ed8", margin: 0 }}>
                  {incidentStats.total}
                </h3>
                <p style={{ fontSize: "14px", color: "#1d4ed8", margin: 0 }}>Total Incidents</p>
              </div>
              <div style={{ backgroundColor: "#fef3c7", padding: "16px", borderRadius: "8px", textAlign: "center" }}>
                <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#b45309", margin: 0 }}>
                  0{incidentStats.open}
                </h3>
                <p style={{ fontSize: "14px", color: "#b45309", margin: 0 }}>Open Incidents</p>
              </div>
            </div>

            {/* Category & Month-wise Charts */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "24px" }}>
              <div
                style={{
                  backgroundColor: "white",
                  border: "2px solid #facc15",
                  borderRadius: "8px",
                  padding: "16px",
                  overflowX: "auto",
                }}
              >
                <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#1d4ed8" }}>
                  Category Wise Incidents Spread YTD 2025
                </h3>
                <Chart options={incidentCategoryOptions} series={incidentCategorySeries} type="bar" height={300} />
              </div>
              <div
                style={{
                  backgroundColor: "white",
                  border: "2px solid #facc15",
                  borderRadius: "8px",
                  padding: "16px",
                }}
              >
                <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#1d4ed8" }}>
                  Incidents Insights YTD 2025
                </h3>
                <Chart options={incidentMonthlyOptions} series={incidentMonthlySeries} type="line" height={300} />
              </div>
            </div>

            {/* Responsibility-Wise Open Incidents */}
            <div
              style={{
                marginTop: "24px",
                backgroundColor: "white",
                border: "2px solid #facc15",
                borderRadius: "8px",
                padding: "16px",
                overflowX: "auto",
              }}
            >
              <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#1d4ed8" }}>
                Open Incidents Responsibility Wise YTD 2025 <span style={{ color: "#b91c1c" }}> (2 Overdue)</span>
              </h3>
              <Chart options={openIncidentsOptions} series={openIncidentsSeries} type="bar" height={300} />
            </div>
          </div>

          {/* Safety KPIs Table */}
          <div style={{ marginTop: "32px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
            <h3
              style={{
                fontSize: "1.125rem",
                fontWeight: "600",
                marginBottom: "12px",
                color: "#1e3a8a",
              }}
            >
              📊 Safety KPI's Monitoring ICF - 17-06-2025
            </h3>
            <DataSource disrupt={false} shenet={false} />
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                <thead style={{ backgroundColor: "#e0f2fe", color: "#1e40af" }}>
                  <tr>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>S#</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Employee Name</th>
                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Department</th>
                    <th colSpan={3} style={{ padding: "8px", border: "1px solid #e5e7eb" }}>Safety Contacts</th>
                    <th colSpan={3} style={{ padding: "8px", border: "1px solid #e5e7eb" }}>SMS</th>
                    <th colSpan={2} style={{ padding: "8px", border: "1px solid #e5e7eb" }}>DCA</th>
                    <th colSpan={2} style={{ padding: "8px", border: "1px solid #e5e7eb" }}>JCC</th>
                  </tr>
                </thead>
                <tbody>
                  {safetyKPIData.map((row, index) => (
                    <tr key={index}>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{index + 1}</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.name}</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.dept}</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.scFort}</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.scTarget}</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.scMTD}%</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.smsFort}</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.smsTarget}</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.smsMTD}%</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.dcaMTD}</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.dcaTarget}</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.jccMTD}</td>
                      <td style={{ padding: "6px", border: "1px solid #e5e7eb" }}>{row.jccTarget}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          
          {/* Report Footer */}
          <p style={{ fontSize: "12px", color: "#6b7280", textAlign: "center", marginTop: "24px" }}>
            This comprehensive daily safety report was generated on {datee}<br />
            For questions or concerns, contact the Safety Department at <a href="mailto:safety@company.com">safety@company.com</a>
          </p>






        </div>
      </div>
    </div>
  )
};

export default DailySafetyReport;
